const cityNames = [
  { name: 'Arlington', link: '/arlington-texas-travel-packages' },
  { name: 'Atlanta', link: '/atlanta-georgia-travel-packages' },
  { name: 'Austin', link: '/austin-texas-travel-packages' },
  { name: 'Baltimore', link: '/baltimore-maryland-travel-packages' },
  { name: 'Barcelona', link: '/barcelona-catalonia-travel-packages' },
  { name: 'Boston', link: '/boston-massachusetts-travel-packages' },
  { name: 'Calgary', link: '/calgary-alberta-travel-packages' },
  { name: 'Charlotte', link: '/charlotte-north-carolina-travel-packages' },
  { name: 'Chicago', link: '/chicago-illinois-travel-packages' },
  { name: 'Cincinnati', link: '/cincinnati-ohio-travel-packages' },
  { name: 'Cleveland', link: '/cleveland-ohio-travel-packages' },
  { name: 'Dallas', link: '/dallas-texas-travel-packages' },
  { name: 'Denver', link: '/denver-colorado-travel-packages' },
  { name: 'Detroit', link: '/detroit-michigan-travel-packages' },
  { name: 'Edmonton', link: '/edmonton-alberta-travel-packages' },
  { name: 'Houston', link: '/houston-texas-travel-packages' },
  { name: 'Kansas City', link: '/kansas-city-missouri-travel-packages' },
  { name: 'Las Vegas', link: '/las-vegas-nevada-travel-packages' },
  { name: 'London, UK', link: '/london-england-travel-packages' },
  { name: 'Los Angeles', link: '/los-angeles-california-travel-packages' },
  { name: 'Manchester', link: '/manchester-england-travel-packages' },
  { name: 'Miami', link: '/miami-florida-travel-packages' },
  { name: 'Milan', link: '/milan-lombardy-travel-packages' },
  { name: 'Minneapolis', link: '/minneapolis-minnesota-travel-packages' },
  { name: 'Montreal', link: '/montreal-quebec-travel-packages' },
  { name: 'Nashville', link: '/nashville-tennessee-travel-packages' },
  { name: 'New Orleans', link: '/new-orleans-louisiana-travel-packages' },
  { name: 'New York', link: '/new-york-new-york-travel-packages' },
  { name: 'Paris', link: '/paris-ile-de-france-travel-packages' },
  { name: 'Philadelphia', link: '/philadelphia-pennsylvania-travel-packages' },
  { name: 'Phoenix', link: '/phoenix-arizona-travel-packages' },
  { name: 'Pittsburgh', link: '/pittsburgh-pennsylvania-travel-packages' },
  { name: 'Portland', link: '/portland-oregon-travel-packages' },
  { name: 'San Diego', link: '/san-diego-california-travel-packages' },
  { name: 'San Francisco', link: '/san-francisco-california-travel-packages' },
  { name: 'Seattle', link: '/seattle-washington-travel-packages' },
  { name: 'Tampa', link: '/tampa-florida-travel-packages' },
  { name: 'Toronto', link: '/toronto-ontario-travel-packages' },
  { name: 'Vancouver', link: '/vancouver-british-columbia-travel-packages' },
  { name: 'Washington, DC', link: '/washington-district-of-colombia-travel-packages' },
]

const cities = cityNames.map(({ name, link }) => ({
  name,
  link,
  children: [],
}))

export const citiesNavigationData = [
  {
    name: 'Cities',
    items: cities,
  },
]
